<template>
    <v-card>
        <v-card-title>{{$t("third_party_insurance_extend")}}</v-card-title>
        <v-card-subtitle></v-card-subtitle>
        <v-card-text>
            <v-form ref="form">
                <v-row>
                    <v-col>
                        <DatePicker
                            :label="$t('end_date')"
                            v-model="endDate"
                            :rules="[isRequired]"
                            dense
                            outlined
                            hide-details="auto"/>
                    </v-col>
                    <v-col>
                        <TimePicker
                            :label="$t('end_time')"
                            v-model="endTime"
                            :rules="[isRequired]"
                            dense
                            outlined
                            hide-details="auto"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            :label="$t('cost')"
                            v-model="form.cost"
                            :rules="[isRequired, isNumeric]"
                            outlined
                            dense
                            hide-details="auto"
                            ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" class="me-2" @click="onSubmit" :loading="loading">
                {{$t("submit")}}
            </v-btn>
            <v-btn text @click="onCancel">
                {{$t("cancel_btn")}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import DatePicker from '../common/DatePicker.vue';
import TimePicker from '../common/TimePicker.vue';
import { isRequired, isNumeric } from './../../utils/validations';
import thirdPartyInsurance from '../../services/insurance/thirdPartyInsurance';

export default {
    components: {
        DatePicker,
        TimePicker
    },
    props: {
        policyId: [Number, String]
    },
    data() {
        return {
            endDate: null,
            endTime: null,
            form: {
                end_at: null,
                cost: 0
            },
            loading: false
        }
    },
    computed: {
        endAt() {
            return `${this.endDate} ${this.endTime}`
        }
    },
    watch: {
        endAt() {
            this.form = {
                ...this.form,
                end_at: this.endAt
            }
        }
    },  
    methods: {
        isRequired, isNumeric,
        onCancel() {
            this.$emit("cancel")
        },
        onSubmit() {
            this.loading = true;
            thirdPartyInsurance.extend(this.policyId, {
                ...this.form,
                cost: Number(this.form.cost)
            }).then((res) => {
                this.$emit("extended", res.data)
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style>

</style>